var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 53 53"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "#1F4970",
    rx: 26.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.563 30.046v-7.682h1.528v7.682zm-3.074-3.08v-1.523h7.682v1.523zm14.127 5.193q-1.068 0-1.92-.409a3.5 3.5 0 0 1-1.352-1.136 3 3 0 0 1-.54-1.648h1.705q.062.75.664 1.233t1.444.483q.67 0 1.187-.307a2.2 2.2 0 0 0 .818-.858q.3-.545.301-1.244 0-.71-.306-1.267a2.27 2.27 0 0 0-.847-.875 2.4 2.4 0 0 0-1.227-.324q-.53 0-1.063.182-.534.18-.864.477l-1.607-.239.653-5.863h6.398v1.505h-4.938l-.37 3.256h.069q.34-.33.903-.551a3.3 3.3 0 0 1 1.216-.222q1.064 0 1.892.506.836.506 1.313 1.38.482.87.477 2 .006 1.131-.511 2.018a3.7 3.7 0 0 1-1.42 1.397q-.904.506-2.075.506"
  })));
};
export default SvgAdd;